// extracted by mini-css-extract-plugin
module.exports =  {"root":"PercentageCell-module__root--u_x03","coloredValue":"PercentageCell-module__coloredValue--yIutG","nonNumericText":"PercentageCell-module__nonNumericText--kwYI5"};